import apiClient from 'services/_infra/apiClient';

export async function clearCameraVideoStreamCache(cameraId) {
  try {
    return await apiClient.delete(
      `/v2/integrations/device/camera/${encodeURIComponent(cameraId)}/video-stream/cache`,
    );
  } catch (error) {
    console.error('Error clearing camera video stream cache:', error);
  }
}

/**
 * Tells the VMS service this client is done watching the camera. The backend stops
 * transcoding only if no other viewer is still pulling the stream (viewer-aware release),
 * otherwise the stream keeps running for the remaining watchers. Best-effort: failures are
 * swallowed because the backend also stops idle streams on its own timeout.
 */
export async function stopCameraVideoStream(cameraId) {
  try {
    return await apiClient.post(
      `/v2/integrations/device/camera/${encodeURIComponent(cameraId)}/video-stream/release`,
    );
  } catch (error) {
    console.error('Error releasing camera video stream:', error);
  }
}
